function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastTaxiTourLandmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 30,
    style: {
      fill: "#838F9B"
    },
    width: 46,
    x: 9,
    y: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.382,16C52.067,7.587,42.686,2,32,2S11.933,7.587,6.618,16H57.382z",
    style: {
      fill: "#F0D0B4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.618,16h50.763c-0.435-0.689-0.907-1.351-1.395-2H8.013C7.525,14.649,7.053,15.311,6.618,16z",
    style: {
      fill: "#ECC19C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16c0-4,5-11,14-14c9,3,14,10,14,14H18z",
    style: {
      fill: "#F5E0CD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.353,14C18.128,14.717,18,15.396,18,16h28c0-0.604-0.128-1.283-0.353-2H18.353z",
    style: {
      fill: "#F0D0B4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.414,16 39.586,16 32,11.701  ",
    style: {
      fill: "#F0D0B4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.943,14 24.414,16 39.586,16 36.057,14  ",
    style: {
      fill: "#ECC19C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,2.033V16h2V2.033C32.667,2.022,32.336,2,32,2S31.333,2.022,31,2.033z",
    style: {
      fill: "#ECC19C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33,12.268 32,11.701 31,12.268 31,16 33,16  ",
    style: {
      fill: "#DFB28B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#AAB2BD"
    },
    width: 56,
    x: 4,
    y: 38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.588,20 62,20 62,16 35.665,16 28.442,16 2,16 2,20 21.5,20  ",
    style: {
      fill: "#DFB28B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    style: {
      fill: "#F5E0CD"
    },
    width: 56,
    x: 4,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#F0D0B4"
    },
    width: 56,
    x: 4,
    y: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.586,16 35.665,16 28.442,16 24.414,16 17.355,20 21.5,20 42.588,20 46.645,20  ",
    style: {
      fill: "#CF9E76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.645,20 17.355,20 4,27.568 4,30 60,30 60,27.568  ",
    style: {
      fill: "#F0D0B4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32,14 62,31 62,32 2,32 2,31  ",
    style: {
      fill: "#969FAA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9,32 32,18.598 55,32  ",
    style: {
      fill: "#CCD1D9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 5,
    y: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,62v-2c0-1.105-0.895-2-2-2H8c-1.105,0-2,0.895-2,2v2H14z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,42v2c0,1.105,0.895,2,2,2h4c1.105,0,2-0.895,2-2v-2H6z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E6E9ED"
    },
    width: 4,
    x: 8,
    y: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,62v-2c0-1.105-0.895-2-2-2h-4c-1.105,0-2,0.895-2,2v2H28z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,42v2c0,1.105,0.895,2,2,2h4c1.105,0,2-0.895,2-2v-2H20z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E6E9ED"
    },
    width: 4,
    x: 22,
    y: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,62v-2c0-1.105-0.895-2-2-2h-4c-1.105,0-2,0.895-2,2v2H44z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,42v2c0,1.105,0.895,2,2,2h4c1.105,0,2-0.895,2-2v-2H36z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E6E9ED"
    },
    width: 4,
    x: 38,
    y: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,62v-2c0-1.105-0.895-2-2-2h-4c-1.105,0-2,0.895-2,2v2H58z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,42v2c0,1.105,0.895,2,2,2h4c1.105,0,2-0.895,2-2v-2H50z",
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E6E9ED"
    },
    width: 4,
    x: 52,
    y: 46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 4,
    style: {
      fill: "#E6E9ED"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#B27946"
    },
    width: 62,
    x: 1,
    y: 61
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 15,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 25,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 35,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 45,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "#AAB2BD"
    },
    width: 4,
    x: 55,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 8,
    x: 6,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 8,
    x: 20,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 8,
    x: 36,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 8,
    x: 50,
    y: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.277,59C50.106,59.295,50,59.634,50,60v1h8v-1c0-0.366-0.106-0.705-0.277-1H50.277z",
    style: {
      fill: "#CCD1D9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.277,59C36.106,59.295,36,59.634,36,60v1h8v-1c0-0.366-0.106-0.705-0.277-1H36.277z",
    style: {
      fill: "#CCD1D9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.277,59C20.106,59.295,20,59.634,20,60v1h8v-1c0-0.366-0.106-0.705-0.277-1H20.277z",
    style: {
      fill: "#CCD1D9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.277,59C6.106,59.295,6,59.634,6,60v1h8v-1c0-0.366-0.106-0.705-0.277-1H6.277z",
    style: {
      fill: "#CCD1D9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 8,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 8,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 22,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 22,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 38,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 38,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 52,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#CCD1D9"
    },
    width: 4,
    x: 52,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 5,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 15,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 5,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 15,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 25,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 25,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 35,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 35,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 45,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 45,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 55,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#969FAA"
    },
    width: 4,
    x: 55,
    y: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastTaxiTourLandmarks);
export default __webpack_public_path__ + "static/media/belfast-taxi-tour-landmarks.b75c91f288db09b8e94c7df97561de3c.svg";
export { ForwardRef as ReactComponent };